import { useState, useMemo } from "react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AccountProfile() {
  const { user, updateProfile } = useAuth();
  const initial = useMemo(() => ({ name: user?.name || "", phone: user?.phone || "" }), [user?.name, user?.phone]);
  const [form, setForm] = useState(initial);
  const [baseline, setBaseline] = useState(initial);
  const [loading, setLoading] = useState(false);

  const dirty = form.name.trim() !== (baseline.name || "").trim() || (form.phone || "").trim() !== (baseline.phone || "").trim();

  const save = async (e) => {
    e.preventDefault();
    if (!dirty || loading) return;
    setLoading(true);
    try {
      await updateProfile({ name: form.name.trim(), phone: form.phone.trim() });
      setBaseline({ name: form.name.trim(), phone: form.phone.trim() });
      toast.success("Profile updated");
    } catch (e) { toast.error(apiError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-6 max-w-lg">
      <h2 className="font-semibold text-slate-900 text-lg mb-4">Profile Details</h2>
      <form onSubmit={save} className="space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700">Full Name</label>
          <input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} data-testid="profile-name"
            className="w-full h-11 px-3 mt-1 rounded-lg border border-slate-200 outline-none focus:border-amber-400 text-sm" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Email</label>
          <input value={user?.email} disabled className="w-full h-11 px-3 mt-1 rounded-lg border border-slate-200 bg-slate-50 text-slate-500 text-sm" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Phone</label>
          <input value={form.phone || ""} onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))} data-testid="profile-phone"
            className="w-full h-11 px-3 mt-1 rounded-lg border border-slate-200 outline-none focus:border-amber-400 text-sm" />
        </div>
        <button disabled={loading || !dirty} className="inline-flex items-center gap-2 bg-slate-900 text-white font-semibold px-5 py-2.5 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed" data-testid="profile-save">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Save Changes
        </button>
      </form>
    </div>
  );
}
